<template>
  <div class="row" style="position: relative">
    <div class="col-sm-8" v-if="user">
      <div class="card">
        <div class="card-header">
          <i class="icon-user"></i>
          {{ user.email }}
          <el-select
            :value="currentStatus && currentStatus.value"
            size="mini"
            @change="handleStatus($event)"
            :disabled="!hasPermission($store.state.user, 'SETTINGS_TEAM_WRITE')"
            class="current-status text-white float-right"
            :style="`background-color: ${
              currentStatus && currentStatus.color
            }; border-radius: 5px;`"
          >
            <el-option
              v-for="status in coachStatus"
              :key="status.value"
              :value="status.value"
              :label="status.label"
              class="text-white"
              :style="`background-color: ${status.color}`"
            />
          </el-select>
        </div>
        <div class="card-block">
          <dl class="row">
            <dt class="col-sm-4">Administrateur</dt>
            <dd class="col-sm-8">
              <el-switch
                ref="toggleAdmin"
                :value="hasRole(user, 'admin')"
                @change="toggleRole"
                :disabled="!hasRole($store.state.user, 'admin')"
              />
            </dd>
            <dt class="col-sm-4">Prénom</dt>
            <dd class="col-sm-8">
              <el-input
                v-model="user.firstName"
                size="mini"
                @change="editFirstName($event)"
                v-if="hasPermission($store.state.user, 'SETTINGS_TEAM_WRITE')"
              />
              <p v-else>{{ user.firstName }}</p>
            </dd>
            <dt class="col-sm-4">Nom de famille</dt>
            <dd class="col-sm-8">
              <el-input
                v-model="user.lastName"
                size="mini"
                @change="editLastName($event)"
                v-if="hasPermission($store.state.user, 'SETTINGS_TEAM_WRITE')"
              />
              <p v-else>{{ user.lastName }}</p>
            </dd>
            <dt
              class="col-sm-4"
              v-if="hasPermission($store.state.user, 'SETTINGS_TEAM_WRITE')"
            >
              Mot de passe
            </dt>
            <dd
              class="col-sm-8"
              v-if="hasPermission($store.state.user, 'SETTINGS_TEAM_WRITE')"
            >
              <button
                @click="modalChangePassword = true"
                class="btn btn-primary btn-sm"
              >
                Changer
              </button>
            </dd>
            <dt class="col-sm-4">Rôle commercial</dt>
            <dd class="col-sm-8">
              <div class="row">
                <div class="col-sm-2">
                  <el-switch
                    :value="
                      user.commercial ? user.commercial.isCommercial : false
                    "
                    @change="toggleCommercial()"
                    :disabled="
                      !hasPermission($store.state.user, 'SETTINGS_TEAM_WRITE')
                    "
                  />
                </div>
                <div
                  class="col-sm-10"
                  v-if="user.commercial && user.commercial.isCommercial"
                >
                  <div class="row">
                    <div class="col-sm-4">
                      <p>Pseudo commercial</p>
                    </div>
                    <div class="col-sm-8">
                      <el-input
                        v-model="user.commercial.pseudo"
                        size="mini"
                        @change="
                          editCommercial({
                            isCommercial: user.commercial.isCommercial,
                            pseudo: $event,
                          })
                        "
                        v-if="
                          hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                      />
                      <p v-else>{{ user.commercial.pseudo }}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <p>Poste</p>
                    </div>
                    <div class="col-sm-8">
                      <el-input
                        v-model="user.commercial.job"
                        size="mini"
                        @change="
                          editCommercial({
                            isCommercial: user.commercial.isCommercial,
                            job: $event,
                          })
                        "
                        v-if="
                          hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                      />
                      <p v-else>{{ user.commercial.job }}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <p>
                        Actif
                        <i
                          class="fa fa-info-circle ml-05"
                          v-tooltip="{
                            content:
                              'Permet d\'être attribué automatiquement à des clients/entreprises',
                            placement: 'right',
                          }"
                        ></i>
                      </p>
                    </div>
                    <div class="col-sm-2">
                      <el-switch
                        v-model="user.commercial.active"
                        @change="
                          editCommercial({
                            active: user.commercial.active,
                          })
                        "
                        :disabled="
                          !hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <p>
                        B2C
                        <i
                          class="fa fa-info-circle ml-05"
                          v-tooltip="{
                            content:
                              'Permet d\'être attribué automatiquement à des clients',
                            placement: 'right',
                          }"
                        ></i>
                      </p>
                    </div>
                    <div class="col-sm-2">
                      <el-switch
                        v-model="user.commercial.isB2C"
                        @change="
                          editCommercial({
                            isB2C: user.commercial.isB2C,
                          })
                        "
                        :disabled="
                          !hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <p>
                        B2B
                        <i
                          class="fa fa-info-circle ml-05"
                          v-tooltip="{
                            content:
                              'Permet d\'être attribué automatiquement à des entreprises',
                            placement: 'right',
                          }"
                        ></i>
                      </p>
                    </div>
                    <div class="col-sm-2">
                      <el-switch
                        v-model="user.commercial.isB2B"
                        @change="
                          editCommercial({
                            isB2B: user.commercial.isB2B,
                          })
                        "
                        :disabled="
                          !hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <p>
                        Masqué
                        <i
                          class="fa fa-info-circle ml-05"
                          v-tooltip="{
                            content: 'N\'apparait pas dans les propositions',
                            placement: 'right',
                          }"
                        ></i>
                      </p>
                    </div>
                    <div class="col-sm-2">
                      <el-switch
                        v-model="user.commercial.hidden"
                        @change="
                          editCommercial({
                            hidden: user.commercial.hidden,
                          })
                        "
                        :disabled="
                          !hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <label>Période à exclure</label>
                      <i
                        class="fa fa-info-circle ml-05"
                        v-tooltip="{
                          content:
                            'Cette fonctionnalité permet de planifier les périodes à exclure, en considérant les dates de début et de fin comme incluses, afin d’anticiper les absences des commerciaux et permettre la réorganisation de la répartition des prospects en conséquence',
                          placement: 'right',
                        }"
                      ></i>
                    </div>
                    <div class="col-sm-2">
                      <el-switch
                        v-model="user.commercial.excludedPeriod"
                        @change="
                          editCommercial({
                            excludedPeriod: $event,
                            excludedPeriodBegin:
                              $event === false
                                ? null
                                : user.commercial.excludedPeriodBegin,
                            excludedPeriodEnd:
                              $event === false
                                ? null
                                : user.commercial.excludedPeriodEnd,
                          })
                        "
                        :disabled="
                          !hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                      />
                    </div>
                  </div>
                  <div class="row" v-if="user.commercial.excludedPeriod">
                    <div class="col-sm-4"></div>
                    <div class="col-sm-6">
                      Du
                      <datepicker
                        v-if="
                          hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                        v-model="user.commercial.excludedPeriodBegin"
                        format="dd.MM.yyyy"
                        language="fr"
                        input-class="form-control"
                        @input="
                          editCommercialDate('excludedPeriodBegin', $event)
                        "
                      ></datepicker>
                      <template v-else>
                        {{ formatDate(user.commercial.excludedPeriodBegin) }}
                      </template>
                    </div>
                  </div>
                  <div class="row mb-2" v-if="user.commercial.excludedPeriod">
                    <div class="col-sm-4"></div>
                    <div class="col-sm-6">
                      au
                      <datepicker
                        v-if="
                          hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                        v-model="user.commercial.excludedPeriodEnd"
                        format="dd.MM.yyyy"
                        language="fr"
                        input-class="form-control"
                        @input="editCommercialDate('excludedPeriodEnd', $event)"
                      ></datepicker>
                      <template v-else>
                        {{ formatDate(user.commercial.excludedPeriodEnd) }}
                      </template>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <p>Mobile</p>
                    </div>
                    <div class="col-sm-8">
                      <PhoneNumberInput
                        v-if="
                          hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                        :phone-number="user.commercial.mobile"
                        :phone-code="user.commercial.phoneCode"
                        size="mini"
                        copy
                        required
                        @changeNumber="
                          editCommercial({
                            isCommercial: user.commercial.isCommercial,
                            mobile: $event,
                          })
                        "
                        @changeCode="
                          editCommercial({
                            isCommercial: user.commercial.isCommercial,
                            phoneCode: $event,
                          })
                        "
                      />
                      <p v-else>
                        <span v-if="user.commercial.phoneCode"
                          >({{ user.commercial.phoneCode }}) </span
                        >{{ user.commercial.mobile }}
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <p>Couleur</p>
                    </div>
                    <div class="col-sm-8">
                      <el-color-picker
                        v-model="user.commercial.color"
                        @change="
                          editCommercial({
                            isCommercial: user.commercial.isCommercial,
                            color: $event,
                          })
                        "
                        :disabled="
                          !hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                      ></el-color-picker>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <p>Photo</p>
                    </div>
                    <div class="col-sm-8">
                      <TeamMemberPicture
                        dropzoneId="photoCommercial"
                        :img="user.commercial.img"
                        :url="getImg"
                        @update="updateCommercialPhoto"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </dd>
            <dt class="col-sm-4">Rôle Coach Manager</dt>
            <dd class="col-sm-8">
              <div class="row">
                <div class="col-sm-2">
                  <el-switch
                    :value="
                      user.coachManager
                        ? user.coachManager.isCoachManager
                        : false
                    "
                    @change="toggleCoachManager()"
                    :disabled="
                      !hasPermission($store.state.user, 'SETTINGS_TEAM_WRITE')
                    "
                  />
                </div>
                <div
                  class="col-sm-10"
                  v-if="user.coachManager && user.coachManager.isCoachManager"
                >
                  <div class="row">
                    <div class="col-sm-4">
                      <p>Pseudo coach manager</p>
                    </div>
                    <div class="col-sm-8">
                      <el-input
                        v-model="user.coachManager.pseudo"
                        size="mini"
                        @change="
                          editCoachManager({
                            isCoachManager: user.coachManager.isCoachManager,
                            pseudo: $event,
                          })
                        "
                        v-if="
                          hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                      />
                      <p v-else>{{ user.coachManager.pseudo }}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <p>Poste</p>
                    </div>
                    <div class="col-sm-8">
                      <el-input
                        v-model="user.coachManager.job"
                        size="mini"
                        @change="
                          editCoachManager({
                            isCoachManager: user.coachManager.isCoachManager,
                            job: $event,
                          })
                        "
                        v-if="
                          hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                      />
                      <p v-else>{{ user.coachManager.job }}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <p>
                        Actif
                        <i
                          class="fa fa-info-circle ml-05"
                          v-tooltip="{
                            content:
                              'Permet d\'être attribué automatiquement à des attributions',
                            placement: 'right',
                          }"
                        ></i>
                      </p>
                    </div>
                    <div class="col-sm-2">
                      <el-switch
                        v-model="user.coachManager.active"
                        @change="
                          editCoachManager({
                            isCoachManager: user.coachManager.isCoachManager,
                            active: $event,
                          })
                        "
                        :disabled="
                          !hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <p>
                        B2C
                        <i
                          class="fa fa-info-circle ml-05"
                          v-tooltip="{
                            content:
                              'Permet d\'être attribué automatiquement à des commandes B2C',
                            placement: 'right',
                          }"
                        ></i>
                      </p>
                    </div>
                    <div class="col-sm-2">
                      <el-switch
                        v-model="user.coachManager.isB2C"
                        @change="
                          editCoachManager({
                            isB2C: user.coachManager.isB2C,
                          })
                        "
                        :disabled="
                          !hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <p>
                        B2B
                        <i
                          class="fa fa-info-circle ml-05"
                          v-tooltip="{
                            content:
                              'Permet d\'être attribué automatiquement à des commandes B2B',
                            placement: 'right',
                          }"
                        ></i>
                      </p>
                    </div>
                    <div class="col-sm-2">
                      <el-switch
                        v-model="user.coachManager.isB2B"
                        @change="
                          editCoachManager({
                            isB2B: user.coachManager.isB2B,
                          })
                        "
                        :disabled="
                          !hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <p>
                        Marchés Publics
                        <i
                          class="fa fa-info-circle ml-05"
                          v-tooltip="{
                            content:
                              'Permet d\'être attribué automatiquement à des commandes marchés publics',
                            placement: 'right',
                          }"
                        ></i>
                      </p>
                    </div>
                    <div class="col-sm-2">
                      <el-switch
                        v-model="user.coachManager.marketEstablishment"
                        @change="
                          editCoachManager({
                            marketEstablishment:
                              user.coachManager.marketEstablishment,
                          })
                        "
                        :disabled="
                          !hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <p>
                        Masqué
                        <i
                          class="fa fa-info-circle ml-05"
                          v-tooltip="{
                            content: 'N\'apparait pas dans les propositions',
                            placement: 'right',
                          }"
                        ></i>
                      </p>
                    </div>
                    <div class="col-sm-2">
                      <el-switch
                        v-model="user.coachManager.hidden"
                        @change="
                          editCoachManager({
                            isCoachManager: user.coachManager.isCoachManager,
                            hidden: $event,
                          })
                        "
                        :disabled="
                          !hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <label>Période à exclure</label>
                      <i
                        class="fa fa-info-circle ml-05"
                        v-tooltip="{
                          content:
                            'Cette fonctionnalité permet de planifier les périodes à exclure, en considérant les dates de début et de fin comme incluses, afin d’anticiper les absences des coachs manager et permettre la réorganisation de la répartition des attributions en conséquence',
                          placement: 'right',
                        }"
                      ></i>
                    </div>
                    <div class="col-sm-2">
                      <el-switch
                        v-model="user.coachManager.excludedPeriod"
                        @change="
                          editCoachManager({
                            excludedPeriod: $event,
                            excludedPeriodBegin:
                              $event === false
                                ? null
                                : user.coachManager.excludedPeriodBegin,
                            excludedPeriodEnd:
                              $event === false
                                ? null
                                : user.coachManager.excludedPeriodEnd,
                          })
                        "
                        :disabled="
                          !hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                      />
                    </div>
                  </div>
                  <div class="row" v-if="user.coachManager.excludedPeriod">
                    <div class="col-sm-4"></div>
                    <div class="col-sm-6">
                      Du
                      <datepicker
                        v-if="
                          hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                        v-model="user.coachManager.excludedPeriodBegin"
                        format="dd.MM.yyyy"
                        language="fr"
                        input-class="form-control"
                        @input="
                          editCoachManagerDate('excludedPeriodBegin', $event)
                        "
                      ></datepicker>
                      <template v-else>
                        {{ formatDate(user.coachManager.excludedPeriodBegin) }}
                      </template>
                    </div>
                  </div>
                  <div class="row mb-2" v-if="user.coachManager.excludedPeriod">
                    <div class="col-sm-4"></div>
                    <div class="col-sm-6">
                      au
                      <datepicker
                        v-if="
                          hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                        v-model="user.coachManager.excludedPeriodEnd"
                        format="dd.MM.yyyy"
                        language="fr"
                        input-class="form-control"
                        @input="
                          editCoachManagerDate('excludedPeriodEnd', $event)
                        "
                      ></datepicker>
                      <template v-else>
                        {{ formatDate(user.coachManager.excludedPeriodEnd) }}
                      </template>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <p>Mobile</p>
                    </div>
                    <div class="col-sm-8">
                      <PhoneNumberInput
                        v-if="
                          hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                        :phone-number="user.coachManager.mobile"
                        :phone-code="user.coachManager.phoneCode"
                        size="mini"
                        copy
                        required
                        @changeNumber="
                          editCoachManager({
                            isCoachManager: user.coachManager.isCoachManager,
                            mobile: $event,
                          })
                        "
                        @changeCode="
                          editCoachManager({
                            isCoachManager: user.coachManager.isCoachManager,
                            phoneCode: $event,
                          })
                        "
                      />
                      <p v-else>
                        <span v-if="user.coachManager.phoneCode"
                          >({{ user.coachManager.phoneCode }}) </span
                        >{{ user.coachManager.mobile }}
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <p>Couleur</p>
                    </div>
                    <div class="col-sm-8">
                      <el-color-picker
                        v-model="user.coachManager.color"
                        @change="
                          editCoachManager({
                            isCoachManager: user.coachManager.isCoachManager,
                            color: $event,
                          })
                        "
                        :disabled="
                          !hasPermission(
                            $store.state.user,
                            'SETTINGS_TEAM_WRITE',
                          )
                        "
                      ></el-color-picker>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <p>Photo</p>
                    </div>
                    <div class="col-sm-8">
                      <TeamMemberPicture
                        dropzoneId="photoCoachManager"
                        :img="user.coachManager.img"
                        :url="getCoachManagerImg"
                        @update="updateCoachManagerPhoto"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </dd>
          </dl>
        </div>
      </div>

      <div class="card" v-if="!hasRole(user, 'admin')">
        <div class="card-header">Autorisations</div>
        <div class="card-block">
          <table class="permissions">
            <thead>
              <tr>
                <th>MENU</th>
                <th class="text-center">CONSULTATION</th>
                <th class="text-center">MODIFICATION</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(set, index) of rightAccessSettings" :key="index">
                <td
                  :style="
                    set.level
                      ? `padding-left: ${set.level * 2}rem`
                      : set.parent
                      ? 'padding-left: 2rem'
                      : ''
                  "
                >
                  {{ set.title }}
                  <i
                    class="fa fa-info-circle ml-05"
                    v-tooltip="{ content: set.info, placement: 'right' }"
                    v-if="set.info"
                  ></i>
                </td>
                <td class="text-center">
                  <el-switch
                    v-if="set.read"
                    :value="hasPermission(user, set.read)"
                    @change="togglePermission(set.read)"
                    :disabled="permissionToggleDisabled(set, 'read')"
                  />
                </td>
                <td class="text-center">
                  <el-switch
                    v-if="set.write"
                    :value="hasPermission(user, set.write)"
                    @change="togglePermission(set.write)"
                    :disabled="permissionToggleDisabled(set, 'write')"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="card" v-if="user">
        <div class="card-header">
          <i class="fa fa-info-circle mr-05"></i> Historique
        </div>
        <div class="card-block">
          <Log :user="user" />
        </div>
      </div>
    </div>
    <ChangePassword
      v-if="user"
      :email="user.email"
      :open="modalChangePassword"
    />
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import Datepicker from "vuejs-datepicker";
import { mapGetters } from "vuex";

import Log from "@/components/utils/Log";
import ChangePassword from "@/components/modal/ChangePassword";

import PhoneNumberInput from "@/components/utils/PhoneNumberInput";
import TeamMemberPicture from "@/components/settings/TeamMemberPicture";

export default {
  components: {
    Log,
    ChangePassword,
    Datepicker,
    PhoneNumberInput,
    TeamMemberPicture,
  },

  data() {
    return {
      user: null,
      modalChangePassword: false,
      form: {
        password: null,
      },
    };
  },

  computed: {
    getImg() {
      return `${axios.defaults.baseURL}users/${this.user.id}/commercial-picture`;
    },

    getCoachManagerImg() {
      return `${axios.defaults.baseURL}users/${this.user.id}/coach-manager-picture`;
    },

    ...mapGetters({
      coachStatus: "getCoachStatus",
      rightAccessSettings: "getRightAccessSettings",
    }),

    currentStatus() {
      if (this.user.coach) {
        const status = this.coachStatus.find(
          (status) => this.user.coach.status === status.value,
        );

        return status;
      }

      return null;
    },
  },

  created() {
    this.getTeamMember();
  },

  methods: {
    async getTeamMember() {
      try {
        const { data } = await this.$api.get(
          "/users/team/" + this.$route.params.id,
        );

        if (!data.coach) {
          data.coach = {
            name: "",
          };
        }

        if (!data.commercial) {
          data.commercial = {
            isCommercial: false,
          };
        }

        if (!data.coachManager) {
          data.coachManager = {
            isCoachManager: false,
            isB2B: false,
            isB2C: false,
            marketEstablishment: false,
          };
        }

        this.user = data;
      } catch (e) {
        this.$errorToast(
          "Impossible de récupérer les informations du membre de l'équipe.",
        );

        this.$router.push({
          name: "teammembers",
        });
      }
    },

    handleStatus(event) {
      this.$confirm({
        message: "Attention, cela va changer le statut de l'équipier.",
        onConfirm: async () => {
          try {
            const { data } = await this.$api.put("/users", {
              email: this.user.email,
              coach: {
                status: event,
              },
            });

            this.user = data;
          } catch (e) {
            this.$errorToast(e);
          }
        },
      });
    },

    updateCommercialPhoto(img) {
      let data = {
        email: this.user.email,
        commercial: {
          isCommercial: this.user.commercial.isCommercial,
          img,
        },
      };

      this.$api.put("/users", data).then(() => {
        this.user.commercial.img = img;
      });
    },

    async editFirstName(value) {
      await this.$api.put("/users", {
        email: this.user.email,
        firstName: value,
      });
    },

    async editLastName(value) {
      await this.$api.put("/users", {
        email: this.user.email,
        lastName: value,
      });
    },

    async editCommercial(commercial) {
      const data = {
        email: this.user.email,
        commercial,
      };

      await this.$api.put("/users", data);

      this.user.commercial = {
        ...this.user.commercial,
        ...commercial,
      };
    },

    async editCommercialDate(field, event) {
      const data = {
        email: this.user.email,
        commercial: {
          [field]: moment(event).toDate(),
        },
      };

      await this.$api.put("/users", data);
    },

    toggleCommercial() {
      this.user.commercial.isCommercial = !this.user.commercial.isCommercial;
      let data = {
        email: this.user.email,
        commercial: {
          isCommercial: this.user.commercial.isCommercial,
        },
      };
      this.$api.put("/users", data).then(() => {});
    },

    updateCoachManagerPhoto(img) {
      let data = {
        email: this.user.email,
        coachManager: {
          isCoachManager: this.user.coachManager.isCoachManager,
          img,
        },
      };

      this.$api.put("/users", data).then(() => {
        this.user.coachManager.img = img;
      });
    },

    async editCoachManager(coachManager) {
      const data = {
        email: this.user.email,
        coachManager,
      };

      await this.$api.put("/users", data);

      this.user.coachManager = {
        ...this.user.coachManager,
        ...coachManager,
      };
    },

    async editCoachManagerDate(field, event) {
      let date = moment(event).endOf("day").toDate();

      if (field === "excludedPeriodBegin") {
        date = moment(event).startOf("day").toDate();
      }

      const data = {
        email: this.user.email,
        coachManager: {
          [field]: date,
        },
      };

      await this.$api.put("/users", data);
    },

    toggleCoachManager() {
      this.user.coachManager.isCoachManager =
        !this.user.coachManager.isCoachManager;
      let data = {
        email: this.user.email,
        coachManager: {
          isCoachManager: this.user.coachManager.isCoachManager,
        },
      };
      this.$api.put("/users", data).then(() => {});
    },

    toggleRole(event) {
      this.$confirm({
        message: "Attention, cela va changer le statut Administrateur !",
        onConfirm: async () => {
          let newRole = this.user.role;

          if (event) {
            newRole = newRole | this.getRole("admin");
          } else {
            newRole = newRole & ~this.getRole("admin");
            newRole = newRole | this.getRole("member");
          }

          try {
            const { data } = await this.$api.put("/users", {
              email: this.user.email,
              role: newRole,
            });

            this.user = data;
          } catch (e) {
            this.$errorToast(e);
          }
        },
      });
    },

    async togglePermission(permission) {
      try {
        let permissions = this.user.permissions || [];

        if (permissions.includes(permission)) {
          permissions = permissions.filter((ele) => ele !== permission);
        } else {
          permissions.push(permission);
        }

        permissions = this.setChildrenPermissions(permissions, permission);

        const { data } = await this.$api.put("/users", {
          email: this.user.email,
          permissions,
        });

        this.user = {
          ...this.user,
          ...data,
        };
      } catch (e) {
        this.$errorToast(e.message || e);
      }
    },

    setChildrenPermissions(permissions, permission) {
      const toggleOn = permissions.includes(permission);

      const children = this.rightAccessSettings.filter(
        (setting) => setting.parent?.name === permission,
      );

      if (children.length > 0) {
        for (const child of children) {
          const type = child.parent.type;
          const childPermission = type === "read" ? child.read : child.write;

          if (!childPermission) {
            continue;
          }

          const userHasChildPermission = permissions.includes(childPermission);

          if (toggleOn && !userHasChildPermission) {
            permissions.push(childPermission);
          } else if (!toggleOn && userHasChildPermission) {
            permissions = permissions.filter(
              (perm) => perm !== childPermission,
            );
          }

          permissions = this.setChildrenPermissions(
            permissions,
            childPermission,
          );
        }
      }

      return permissions;
    },

    permissionToggleDisabled(setting, type) {
      if (!this.hasPermission(this.$store.state.user, "SETTINGS_TEAM_WRITE")) {
        return true;
      }

      if (setting.parent?.type === type) {
        return (
          !this.user.permissions ||
          (this.user.permissions &&
            !this.user.permissions.includes(setting.parent.name))
        );
      }

      return false;
    },

    handleChangePassword() {
      let data = {
        email: this.user.email,
        password: this.form.password,
      };
      this.$api
        .put("/users", data)
        .then(() => {
          this.form.password = null;
          this.modalChangePassword = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="css" scoped>
table.permissions th,
table.permissions td {
  padding-right: 32px;
  padding-bottom: 12px;
}
</style>
